import { ROUTE_PATHS } from '@/shared/constants/routes';
import type { IconName } from '@/shared/ui';

/** 좌측 메뉴 — 기획 화면 흐름 순서 그대로. 아이콘은 기본 / 선택 상태 */
export const SIDEBAR_MENUS: ReadonlyArray<{
  label: string;
  to: (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];
  icon: IconName;
  activeIcon: IconName;
}> = [
  {
    label: '업체',
    to: ROUTE_PATHS.USERS,
    icon: 'user',
    activeIcon: 'userActive',
  },
  {
    label: '거래처 정보',
    to: ROUTE_PATHS.CLIENTS,
    icon: 'hospital',
    activeIcon: 'hospitalActive',
  },
  {
    label: '처방 등록 현황',
    to: ROUTE_PATHS.PRESCRIPTIONS,
    icon: 'docs',
    activeIcon: 'docsActive',
  },
];
